import type { ContractPlans } from '@/types/domain/Company'
import type { UserDisplayMode as UserDisplayModeType } from '@/constants/enums/UserDisplayMode'

import { isUserDisplayMode } from '@/constants/enums/UserDisplayMode'

/**
 * Constants
 */
const LOCAL_STORAGE_KEY = 'nuxt-user-display-mode'
// 設定可能なユーザーの表示モード

/**
 * バイヤー兼サプライヤーであるか
 * @param contractPlans 契約プラン
 * @returns boolean バイヤー兼サプライヤーであるか
 */
export const isBuyerAndSupplier = (contractPlans: ContractPlans): boolean => {
  return (
    (contractPlans.buyer || contractPlans.guestBuyer)
    && (contractPlans.supplier || contractPlans.guestSupplier)
  )
}

/**
 * ユーザーの表示モードを取得する
 * @returns userDisplayMode ユーザーの表示モード
 * @returns null ユーザーの表示モードが存在しない場合
 */
export const getUserDisplayMode = (): string | null => {
  return localStorage.getItem(LOCAL_STORAGE_KEY)
}

/**
 * ユーザーの表示モードを保存する
 * @param userDisplayMode ユーザーの表示モード
 * @returns void
 */
export const saveUserDisplayMode = (
  userDisplayMode: UserDisplayModeType,
): void => {
  if (!isUserDisplayMode(userDisplayMode)) {
    return
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, userDisplayMode)
}

/**
 * デフォルトの表示モードを取得する
 * @param contractPlans 契約プラン
 * @returns userDisplayMode ユーザーの表示モード
 */
const getDefaultUserDisplayMode = (
  contractPlans: ContractPlans,
): UserDisplayModeType => {
  if (contractPlans.buyer || contractPlans.guestBuyer) {
    return 'buyer'
  }
  return 'supplier'
}

/**
 * ユーザーの表示モードの初期値を取得する
 * @param contractPlans 契約プラン
 * @returns userDisplayMode ユーザーの表示モード
 */
export const getInitialUserDisplayMode = (
  contractPlans: ContractPlans,
): UserDisplayModeType => {
  const defaultUserDisplayMode = getDefaultUserDisplayMode(contractPlans)

  if (!isBuyerAndSupplier(contractPlans)) {
    return defaultUserDisplayMode
  }

  const userDisplayMode = getUserDisplayMode()

  if (!isUserDisplayMode(userDisplayMode)) {
    return defaultUserDisplayMode
  }

  return userDisplayMode
}
